module.exports = __webpack_public_path__ + "26c8d1c10b052c3a1d6721d23b7f7051.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/labrador-population.svg
// module id = 79
// module chunks = 0